
import APIClient from './APIClient'

class CReportsAPI {

  async getLastPayPeriod() {
    const res = await APIClient.GET('/reports/last-pay-period')
    return res
  }

  async getPayReport(start_date) {
    const res = await APIClient.GET('/reports/pay', { start_date })
    return res
  }

  async lockPayReport(id, payReportData) {
    const res = await APIClient.POST(`/reports/pay/${id}`, payReportData)
    return res
  }

  async listBreakReports(params) {
    const q = {}
    if (params.search) q.search = params.search 
    if (!isNaN(params.skip)) q.skip = params.skip 
    if (!isNaN(params.limit)) q.limit = params.limit
    const res = await APIClient.GET('/reports/break', Object.keys(q).length > 0 ? q : undefined)
    return res
  }

}

const ReportsAPI = new CReportsAPI()

export default ReportsAPI



// WEBPACK FOOTER //
// ./src/api/ReportsAPI.js